import React, { useCallback, useEffect, useState } from 'react';
import {
  Route, Routes, useNavigate,
} from 'react-router-dom';
import Header from 'components/Admin/Header';
import Accounts from 'screens/Admin/Accounts';
import CrmScreen from 'screens/Admin/Crm';
import Investors from 'screens/Admin/Investors';
import Projects from 'screens/Admin/Projects';
import {
  ROUTE_ADMIN_ACCOUNT_INVESTORS,
  ROUTE_ADMIN_ACCOUNT_PROJECTS,
  ROUTE_ADMIN_ACCOUNTS,
  ROUTE_ADMIN_EVENTS,
  ROUTE_ADMIN_INVESTOR_ACCOUNTS,
  ROUTE_ADMIN_INVESTOR_PROJECTS,
  ROUTE_ADMIN_INVESTORS, ROUTE_ADMIN_INVITATIONS, ROUTE_ADMIN_PROFILE,
  ROUTE_ADMIN_PROJECT_ACCOUNTS, ROUTE_ADMIN_PROJECT_INVESTORS,
  ROUTE_ADMIN_PROJECTS,
  ROUTE_ADMIN_CRM,
  ROUTE_ADMIN_DOCS,
  ROUTE_ADMIN_ACCOUNT_DOCS,
  ROUTE_ADMIN_DOCS_REQUEST_TEMPLATE,
  ROUTE_ADMIN_DOCS_GENERAL,
  ROUTE_ADMIN_PROCESSES,
} from 'constants/routes';
import handlePromise from 'utils/Promise';
import ProfileService from 'services/api/Profile';
import AuthService from 'services/api/Auth';
import { Spinner } from 'react-bootstrap';

import Profile from '../../User/Profile';
import Invitations from '../Invitations';
import EventManagementScreen from '../EventManagement';
import DocsRequestTemplateSscreen from '../DocsRequestTemplates';
import DocsScreen from '../Docs';
import DocsDashboardScreen from '../DocsDashboard';
import ProcessesScreen from '../Processes';

function AdminLayout() {
  const [profile, setProfile] = useState<any>();
  const navigate = useNavigate();
  const [readyLayout, setReadyLayout] = useState<boolean>( false );

  const getApiVersion = useCallback( async () => {
    await handlePromise( AuthService.getApiVersion() );
  }, [] );

  const getProfile = useCallback( async () => {
    const [, profileResponse, profileData] = await handlePromise( ProfileService.getProfile() );
    if ( profileData?.isNew ) {
      navigate( '/force-change-password' );
      return;
    }
    if ( profileResponse.ok ) setProfile( profileData );
    setTimeout( () => {
      setReadyLayout( true );
    }, 800 );
  }, [] );

  useEffect( () => {
    getApiVersion();
    getProfile();
  }, [] );

  return (
    <>
      <Header profile={profile} />
      {readyLayout ? (
        <Routes>
          <Route path={ROUTE_ADMIN_ACCOUNT_PROJECTS} element={<Projects />} />
          <Route path={ROUTE_ADMIN_ACCOUNT_INVESTORS} element={<Investors />} />
          <Route path={ROUTE_ADMIN_ACCOUNT_DOCS} element={<DocsScreen />} />
          <Route path={ROUTE_ADMIN_ACCOUNTS} element={<Accounts />} />
          <Route path={ROUTE_ADMIN_INVESTOR_ACCOUNTS} element={<Accounts />} />
          <Route path={ROUTE_ADMIN_INVESTOR_PROJECTS} element={<Projects />} />
          <Route path={ROUTE_ADMIN_INVESTORS} element={<Investors />} />
          <Route path={ROUTE_ADMIN_PROJECT_ACCOUNTS} element={<Accounts />} />
          <Route path={ROUTE_ADMIN_PROJECT_INVESTORS} element={<Investors />} />
          <Route path={ROUTE_ADMIN_PROFILE} element={<Profile />} />
          <Route path={ROUTE_ADMIN_PROJECTS} element={<Projects />} />
          <Route path={ROUTE_ADMIN_INVITATIONS} element={<Invitations />} />
          <Route path={ROUTE_ADMIN_EVENTS} element={<EventManagementScreen />} />
          <Route
            path={ROUTE_ADMIN_DOCS_REQUEST_TEMPLATE}
            element={<DocsRequestTemplateSscreen />}
          />
          <Route path={ROUTE_ADMIN_CRM} element={<CrmScreen />} />
          <Route path={ROUTE_ADMIN_DOCS} element={<DocsScreen />} />
          <Route path={ROUTE_ADMIN_DOCS_GENERAL} element={<DocsDashboardScreen />} />
          <Route path={ROUTE_ADMIN_PROCESSES} element={<ProcessesScreen />} />
        </Routes>
      )
        : (
          <div className="app-loading">
            <Spinner
              animation="border"
              variant="primary"
              style={{
                width: '3rem',
                height: '3rem',
              }}
            />
          </div>
        )}
    </>
  );
}

export default AdminLayout;
